<template>
    <div name="map-search-bottom" class="bar" id="map-search-bottom">
        <span class="title">가까운 <span style="font-weight: 600;">인슐린·바크시미 약국</span>을 한눈에!</span>
        <!-- 목록 화면과 같은 스토어 값을 쓰므로 선택이 공유된다 -->
        <medicine-filter compact style="margin-top: 14px;" />
        <div class="search-wrap">
            <img src="../../../assets/search.png" class="search-icn" @click="onSearch" />
            <input class="input-big" 
                style="padding-left: 37px;"
                v-focus-background
                @input="onInput" 
                v-model="keyword"
                ref="searchInput"
                placeholder="약국명, 주소, 인슐린 검색"
            />
        </div>

    </div>
</template>

<script>
import focusBackground from '@/components/directives/focusBackground';
import { debounce } from 'lodash';
import MedicineFilter from '@/components/molecules/maps/MedicineFilter';

export default {
    name: 'mapSearchBottom',
    components: {
        MedicineFilter
    },
    props:['preKeyword'],
    data: function()
    {
        return {
            keyword: this.preKeyword
        }
    },
    directives: {
        focusBackground
    },
    methods: {
        onSearch: function()
        {
            this.$emit('onSearch', this.keyword); 
        },
        onInput: debounce(function (event) {
            this.keyword = event.target.value
            this.$emit('onSearch', event.target.value);
        }, 500),
    }

}
</script>

<style scoped>
    .bar {
        position: absolute;
        bottom: 0;
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 190px;
        flex-shrink: 0;
        border-radius: 15px 15px 0 0;
        background: #FFF;
        box-sizing: border-box;
        padding: 20px 16px;
        justify-content: flex-start;
        align-items: center;
        z-index: 100;
    }
    .search-wrap {
        position: relative;
        width: 100%;
        margin-top: 12px;
    }
    .input-big {
        display: block;
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
    .search-icn {
        width: 22px;
        position: absolute;
        top: 50%;
        left: 8px;
        transform: translate(0, -50%);
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/maps/MapSearchBottom.vue